import { Box, EmptyView, Loader, Spacer, TextInput } from '@jfs/ui-new'
import { StackActions, useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { DataProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'
import { AepsButton } from '../../comps/AepsButton'
import { Container } from '../../comps/Container'
import { Title } from '../../comps/Title'
import { useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { getErrorMessage } from '../../util/utill'
import { SearchBar } from './SearchBar'
import { TransactionListItem } from './TransactionListItem'

const IS_NEW_DESIGN = true

export const TransactionEnquiryScreen = () => {
  const navigation = useNavigation()
  const [tnxId, setTnxId] = useState('')

  const { fetchParticularTransactionApi, fetchTransactionHistoryApi, updateTransactionForStatus } = useStores(
    (root) => ({
      fetchParticularTransactionApi: root.customer.fetchParticularTransactionApi,
      fetchTransactionHistoryApi: root.customer.fetchTransactionHistoryApi,
      updateTransactionForStatus: root.customer.updateTransactionForStatus,
    }),
  )

  const [lazyFtchParticularTransactionApi, fetchParticularTransactionApiHandler] =
    useLazyApiData(fetchParticularTransactionApi)
  const [lazyFetchTransactionHistoryApi, fetchTransactionHistoryApiHandler] = useLazyApiData(fetchTransactionHistoryApi)

  const [_dataProvider, setDataProvider] = useState(
    new DataProvider((r1, r2) => {
      return r1 !== r2
    }),
  )

  useEffect(() => {
    if (fetchTransactionHistoryApiHandler.state === 'fulfilled') {
      setDataProvider(
        new DataProvider((r1, r2) => {
          return r1 !== r2
        }).cloneWithRows(fetchTransactionHistoryApiHandler.data),
      )
    }
  }, [fetchTransactionHistoryApiHandler.data, fetchTransactionHistoryApiHandler.state])

  useEffect(() => {
    if (IS_NEW_DESIGN) {
      lazyFetchTransactionHistoryApi()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [layoutProvider] = useState(
    new LayoutProvider(
      (_) => {
        return 'LIST_ITEM'
      },
      (_, dim) => {
        dim.width = Math.round(Dimensions.get('window').width)
        dim.height = 100
      },
    ),
  )

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Transactions' })
  }, [navigation])

  useEffect(() => {
    if (fetchParticularTransactionApiHandler.state === 'fulfilled') {
      navigation.dispatch(
        StackActions.push(Screens.CASH_WITHDRAWAL_STATUS as never, { type: 'fetch_perticular_transaction' }),
      )
    }
  }, [fetchParticularTransactionApiHandler, navigation])

  const onPress = () => {
    lazyFtchParticularTransactionApi(tnxId)
  }
  const onItemPress = (data: any) => {
    updateTransactionForStatus(data)
    navigation.dispatch(
      StackActions.push(Screens.CASH_WITHDRAWAL_STATUS as never, { type: 'fetch_perticular_transaction' }),
    )
  }
  let errorMessage =
    fetchParticularTransactionApiHandler?.state === 'rejected' &&
    fetchParticularTransactionApiHandler?.data?.code === '305' &&
    fetchParticularTransactionApiHandler?.data?.transactionId === tnxId &&
    fetchParticularTransactionApiHandler?.data?.message

  const rowRenderer = (_: any, data: any) => {
    return <TransactionListItem data={data} onPress={onItemPress} />
  }

  return (
    <Container
      showFooter={true}
      isLoading={
        fetchParticularTransactionApiHandler.state === 'pending' ||
        fetchTransactionHistoryApiHandler.state === 'pending'
      }
      paddingHorizontal={IS_NEW_DESIGN ? 0 : 16}>
      {!IS_NEW_DESIGN && (
        <>
          <Box f={1} overflow={'scroll'}>
            <Title title={`Please enter the transaction ID${'\n'}for the search`} />
            <Box width={'100%'} paddingVertical={56} paddingHorizontal={24}>
              <TextInput
                fontSize={18}
                testID="tnxid-input"
                placeholder="Transaction ID"
                textAlign={'center'}
                color={'PRIMARY_GREY'}
                value={tnxId}
                onChangeText={(txt: string) => {
                  setTnxId(txt)
                }}
                keyboardType="numeric"
                error={errorMessage}
                touched={true}
                errorTextVerticalSpacing={8}
                errorTextAlign="center"
                errorTextFontWeight={'BOLD'}
              />
            </Box>
          </Box>
          <AepsButton
            onPress={onPress}
            title={'Submit'}
            isLoading={fetchParticularTransactionApiHandler.state === 'pending'}
            disabled={tnxId.trim().length === 0}
          />
        </>
      )}
      {IS_NEW_DESIGN && (
        <>
          <SearchBar onSearchClick={(tnxId: any) => lazyFtchParticularTransactionApi(tnxId)} />
          <Spacer direction="vertical" size={16} />
          {_dataProvider.getSize() === 0 && (
            <Box f={1} justify="center" alignItems={'center'}>
              <EmptyView
                onRetry={() => lazyFetchTransactionHistoryApi()}
                isLoading={fetchTransactionHistoryApiHandler.state === 'pending'}
                loaderComponent={<Loader type="large" color="PRIMARY_STORNG" />}
                error={
                  getErrorMessage(fetchTransactionHistoryApiHandler) && {
                    networkError: {
                      data: { errors: [{ details: getErrorMessage(fetchTransactionHistoryApiHandler) }] },
                    },
                  }
                }
                emptyMessage={fetchTransactionHistoryApiHandler.state === 'fulfilled' ? 'No transactions Found' : ''}
              />
            </Box>
          )}
          {_dataProvider.getSize() > 0 && (
            <RecyclerListView rowRenderer={rowRenderer} dataProvider={_dataProvider} layoutProvider={layoutProvider} />
          )}
        </>
      )}
    </Container>
  )
}
